import React from 'react'

import { Box } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'

export type ActivityIconProps = {
  size?: number
  color?: string
  colorScheme?: ColorScheme
}

export const ActivityIcon = ({
  size = 18,
  color,
  colorScheme,
}: ActivityIconProps) => (
  <Box
    alignItems='center'
    color={
      color ??
      (colorScheme === 'light' ? 'light.icon.secondary' : 'icon.secondary')
    }
    display='flex'
    flexShrink={0}
    height={`${size}px`}
    lineHeight={0}
    width={`${size}px`}
  >
    <svg
      fill='none'
      height={size}
      viewBox='0 0 18 17'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M17 8.5H13.667L11.167 16L6.167 1L3.667 8.5H0.333'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.5'
      />
    </svg>
  </Box>
)
